<template>
  <div :key="placeholder">
    <div class="textarea">
      <a class="save" v-show="saveIconStatus" @click="save()"
        ><font-awesome-icon icon="save"
      /></a>
      <quill-editor
        class="notranslate"
        v-model="mutation"
        ref="myTextEditor"
        :options="editorOption"
        @change="onEditorChange($event)"
      ></quill-editor>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    quillEditor
  },
  props: {
    code: String,
    name: String,
    value: String,
    placeholder: String,
    dbTable: String,
    richEditor: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      type: "content",
      mutation: "",
      richEditorValue: "",
      originValue: "",
    };
  },
  mounted() {
    this.mutation = this.value || "";
    if (this.richEditor) {
      try {
        this.setRichEditorContent(JSON.parse(this.mutation).ops);
      } catch (err) {
        let d = {
          ops: [{ insert: this.mutation }]
        };
        this.setRichEditorContent(d);
        console.log(err);
      }
      this.originValue = this.getRichEditorContent();
      this.richEditorValue = this.getRichEditorContent();
    } else {
      this.originValue = this.mutation;
    }
  },
  computed: {
    editorOption() {
      return {
        // some quill options
        modules: {
                  toolbar: [
                    ["bold", "italic", "underline", "strike"], //加粗，斜體，下劃線，刪除線
                    // ['blockquote', 'code-block'],     //引用，程式碼塊
                    // [{ 'header': 1 }, { 'header': 2 }],        // 標題，鍵值對的形式；1、2表示字型大小
                    [{ list: "ordered" }, { list: "bullet" }], //列表
                    // [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下標
                    // [{ 'indent': '-1'}, { 'indent': '+1' }],     // 縮排
                    // [{ 'direction': 'rtl' }],             // 文字方向
                    [{ size: ["small", false, "large", "huge"] }], // 字型大小
                    [{ color: [] }, { background: [] }], // 字型顏色，字型背景顏色
                    // [{ 'font': [] }],     //字型
                    // [{ 'align': [] }],    //對齊方式
                    ["clean"] //清除字型樣式
                  ]
                },
                placeholder: this.placeholder,
                theme: "snow"
        }
      },
    saveIconStatus() {
      return JSON.stringify(this.richEditorValue) !== JSON.stringify(this.originValue);
    }
  },
  methods: {
    save() {
      console.log("save");
      if (this.saveIconStatus) {
        this.originValue = this.getRichEditorContent();
        this.$emit("update-input", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.getRichEditorContent(),
          origin: this.originValue,
          type: this.type,
          warning: this.saveIconStatus
        });
      }
    },
    onEditorChange(quill) {
      this.richEditorValue = this.getRichEditorContent();
    },
    setRichEditorContent(value) {
      this.$refs.myTextEditor.quill.setContents(value);
    },
    getRichEditorContent() {
      return JSON.stringify(this.$refs.myTextEditor.quill.getContents());
    },
    emitEditStatusEventToParent() {
      console.log("savedEventToParent in!!!")
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit('change-edit-status', changeStatusData)
    }
  },
  watch: {
    saveIconStatus: function(newVal, oldVal) {
      console.log("saveIconStatus: ", newVal, oldVal)
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
